import React from 'react';
import { Link } from 'react-router-dom';

import { getSerializedObject } from '../../serializers';
import { validateWysiwygEditor } from '../../validators';
import { ButtonStyled, Container, GridCellCustom, GridCustom, Text, TextFieldCustom } from '../common';
import { BaseComponent } from './common';
import { DraftToComponents } from './zarzadzanieTrescia';
import { redirectToLoginView } from '../../helpers';
import { URLS } from '../../urls/frontend';


class LandingPage extends BaseComponent {

    // handlers

    handleFetchSuccess(data) {
        super.handleFetchSuccess(data);

        // if it is preview for zarzadzanie trescia, get data from props
        const content = this.props.content;
        let trescPreviewId = null;
        if (this.props.content) {
            trescPreviewId = content.id;
        }

        let state = {initializingOn: false,};
        const tresciOgolne = getSerializedObject(
            data, {nonRecursiveKeys: ['tresc', ]}).tresciOgolne;
        for (let i of [1, 2, 3]) {
            let to = tresciOgolne.filter(to => to.placement === `homepage_box${i}`)[0];
            if (to) {
                if (trescPreviewId !== null && to.id === trescPreviewId) {
                    to = content;
                }
            } else {
                to = {};
            }
            state[`homepageBox${i}`] = to;
        }
        this.setState(state);
    }

    handleFetchError(data) {
        // do nothing, don't render error
        this.xhrFetch = null;     // clean xhr object
        this.setState({initializingOn: false});
    }

    handleFetchIncorrectStatus(message) {
        this.handleFetchError({});
    }

    handleSearch = () => {
        this.props.history.push(this.getSearchUrl(this.state.query));
    }

    handleNewsletter = () => {
        if(this.props.user?.id !== null) {
            this.props.history.push(URLS.newsletter.path)
            return;
        }

        sessionStorage.setItem(
          "currentPathname",
          URLS.newsletter.path
        );

        redirectToLoginView(false);
    }

    // helpers

    getAdditionalState(props) {
        return {
            homepageBox1: {},
            homepageBox2: {},
            homepageBox3: {},
            query: '',
        }
    }

    getFetchUrl() {
        return '/api/general-content'
    }

    getSearchUrl(query) {
        if (!query.length) {
            return '/ogloszenia/szukaj'
        }
        return encodeURI(`/ogloszenia/szukaj?q=${query}`)
    }

    // rendering

    renderContent() {
        document.title = "Baza Konkurencyjności";
        const {
            homepageBox1,
            homepageBox2,
            homepageBox3
        } = this.state;

        const homepageBox1IsEmpty = Object.keys(homepageBox1).length === 0 || !validateWysiwygEditor(Object.keys(homepageBox1.tresc).length > 0 ? homepageBox1.tresc : '');
        const homepageBox2IsEmpty = Object.keys(homepageBox2).length === 0 || !validateWysiwygEditor(Object.keys(homepageBox2.tresc).length > 0 ? homepageBox2.tresc : '');
        const homepageBox3IsEmpty = Object.keys(homepageBox3).length === 0 || !validateWysiwygEditor(Object.keys(homepageBox3.tresc).length > 0 ? homepageBox3.tresc : '');
        if (homepageBox1IsEmpty && homepageBox2IsEmpty && homepageBox3IsEmpty) {
            return this.renderSearch()
        }

        return (
            <>
                {this.renderSearch()}
                {!homepageBox1IsEmpty && this.renderTrescOgolna(homepageBox1)}
                <GridCustom flexM fullwidth className=" landing-page-contacts">
                    <GridCellCustom>
                        {this.renderContactInfoBlock()}
                    </GridCellCustom>
                </GridCustom>
            </>
        )
    }

    renderSearch() {
        return (
          <Container className="search">
            <GridCustom flexL fullwidth centerVertical>
              <form
                onSubmit={this.handleSearch}
                className="search__form"
                role="search"
              >
                <label className="sr-only" htmlFor="search_input_id">
                  Wyszukaj ogłoszenie
                </label>
                <section className="search__input-container">
                  <div className="search__examples">
                    <Text>Na przykład:</Text>
                    <Link
                      to={this.getSearchUrl("roboty budowlane")}
                      className="link-text link-text--primary"
                    >
                      <span className="sr-only">Sugerowana fraza: </span>roboty
                      budowlane,
                    </Link>
                    <Link
                      to={this.getSearchUrl("dostawa komputerów")}
                      className="link-text link-text--primary"
                    >
                      <span className="sr-only">Sugerowana fraza: </span>dostawa
                      komputerów,
                    </Link>
                    <Link
                      to={this.getSearchUrl("szkolenie pracowników")}
                      className="link-text link-text--primary"
                    >
                      <span className="sr-only">Sugerowana fraza: </span>
                      szkolenie pracowników.
                    </Link>
                  </div>
                  <TextFieldCustom
                    className="search__input"
                    id="search_input_id"
                    maxLength={250}
                    onChange={(ev) => this.setState({ query: ev.target.value })}
                    onClear={(ev) => this.setState({ query: "" })}
                    placeholder="Wpisz, czego szukasz"
                    value={this.state.query}
                  />
                </section>
                <ButtonStyled
                  onClick={this.handleSearch}
                  primary
                  icon="search"
                  className="search__btn"
                >
                  Wyszukaj ogłoszenie
                </ButtonStyled>
                <ButtonStyled
                  onClick={(ev) => {
                    ev.preventDefault();
                    this.handleNewsletter();
                  }}
                  lite
                  icon="mail"
                  className="search__btn"
                >
                  Zapisz się na newsletter ogłoszeń<span className="sr-only"> Zaloguj się, aby zapisać się na newsletter</span>
                </ButtonStyled>
              </form>
              <section className="search__secondary">
                {this.renderAddOgloszenieLink()}
              </section>
            </GridCustom>
          </Container>
        );
    }

    renderAddOgloszenieLink() {
        const user = this.props.user;
        if (!user || user.identifier === null) {
            return (
                <>
                    <ButtonStyled
                        className="search__btn"
                        icon="library_add"
                        lite
                        noMargin
                        onClick={this.props.onLoginClick}
                    >
                        Dodaj ogłoszenie<span className="sr-only"> Zaloguj się, aby dodać ogłoszenie</span>
                    </ButtonStyled>
                    <Text className="search__info">Wymaga logowania</Text>
                </>
            )
        }
        return (
            <ButtonStyled
                tag={Link}
                to="/ogloszenia/nowe"
                id="dodaj_ogloszenie_button_id"
                lite
                noMargin
                icon="library_add"
                className="search__btn">
                Dodaj ogłoszenie
            </ButtonStyled>
        )
    }

    renderTrescOgolna(element) {
        return (
            <Container title={element.naglowek}>
                <DraftToComponents content={element.tresc} />
            </Container>
        )
    }

    renderContactInfoBlock() {
        return (
            <Container title='Wsparcie dla użytkowników'>
                <section>{this.renderContactInfoContent()}</section>
            </Container>
        )
    }

    renderContactInfoContent() {
        const emails = [
          {code: "FAMI", address: "amiz.fami@mswia.gov.pl"},
          {code: "FBWP", address: "amiz.fbwp@mswia.gov.pl"},
          {code: "FEDR", address: "amiz.ryby@minrol.gov.pl"},
          {code: "FEDS", address: "amiz.feds@dolnyslask.pl"},
          {code: "FEKP", address: "amiz.rpkp@kujawsko-pomorskie.pl"},
          {code: "FELB", address: "amiz.felb@rpo.lubuskie.pl"},
          {code: "FELD", address: "amiz.feld@lodzkie.pl"},
          {code: "FELU", address: "amiz.felu@lubelskie.pl"},
          {code: "FEMA", address: "amiz.fema@mazovia.pl"},
          {code: "FEMP", address: "amiz.femp@umwm.malopolska.pl"},
          {code: "FENG", address: "amiz.feng@mfipr.gov.pl"},
          {code: "FENX", address: "amiz.fenx@mfipr.gov.pl"},
          {code: "FEOP", address: "amiz.rpop@opolskie.pl"},
          {code: "FEPD", address: "amiz.fepd@podlaskie.eu"},
          {code: "FEPK", address: "amiz.fepk@podkarpackie.pl"},
          {code: "FEPM", address: "amiz.fepm@pomorskie.eu"},
          {code: "FEPW", address: "amiz.fepw@mfipr.gov.pl"},
          {code: "FEPZ", address: "amiz.fepz@wzp.pl"},
          {code: "FERC", address: "amiz.ferc@mfipr.gov.pl"},
          {code: "FERS", address: "amiz.fers@mfipr.gov.pl"},
          {code: "FESL", address: "amiz.fesl@slaskie.pl"},
          {code: "FESW", address: "amiz.fesw@sejmik.kielce.pl"},
          {code: "FEWM", address: "amiz.fewm@warmia.mazury.pl"},
          {code: "FEWP", address: "amiz.fewp@umww.pl"},
          {code: "IZGW", address: "amiz.izgw@mswia.gov.pl"},
          {code: "KPOD", address: "amiz.kpod@mfipr.gov.pl"},
          {code: "PLSK", address: "amiz.plsk@mfipr.gov.pl"},
          {code: "PLSN", address: "amiz.plsn@mfipr.gov.pl"},
          {code: "PLUA", address: "amiz.plua@mfipr.gov.pl"},
          {code: "PTFE", address: "amiz.ptfe@mfipr.gov.pl"},
          {code: "STHB", address: "amiz.sthb@mfipr.gov.pl"}
        ];

        const mainEmail = { address: 'konkurencyjnosc@mfipr.gov.pl'}

        return (
            <div>
                <div className='contact-info-block'>
                    <p>W przypadku wątpliwości w zakresie działania systemu, prosimy o zapoznanie się z treścią Pomocy, umieszczoną na dole strony głównej.</p>
                </div>
                <div className='contact-info-block'>
                    <p className='label'>Wsparcie dla zamawiających</p>
                    <p>Dla naborów/projektów rozpoczynających się od:</p>
                    { this.renderContactList(emails) }
                </div>
                <div className='contact-info-block'>
                    <p>Dla naborów/projektów z innym oznaczeniem:</p>
					<ul className="email-list">
						{ this.renderContactItem(mainEmail, 'other') }
					</ul>
                </div>
                <div className='contact-info-block'>
					<p className='label'>Wsparcie dla oferentów</p>
					<p>Dla wszystkich naborów/projektów:</p>
					<ul className="email-list">
						{ this.renderContactItem(mainEmail, 'tenderer') }
					</ul>
                </div>
            </div>
        )
    }

    renderContactList(emails) {
        return (
            <ul className="email-list">
              {emails.map((email) => this.renderContactItem(email, email.code))}
            </ul>
        )
    }

    renderContactItem(email, key) {
         return (
            <li key={key}>
              {email.code && (
                  <span>{email.code} - </span>
               )}
              <a id={`a11y-url-${email.code || 'main'}`} href={`mailto:${email.address}`} className="link-text" >{email.address}</a>
            </li>
         )
    }
}


export { LandingPage };
